import { backgroundColor } from 'assets/jss/material-dashboard-pro-react';
import typographyStyle from 'assets/jss/material-dashboard-pro-react/components/typographyStyle';

const oneLineStyle = (theme) => ({
	lineContainer: {
		display: 'flex',
		maxWidth: 327,
		alignItems: 'center',
		marginTop: '20px',
		marginBottom: '20px'

	},
	lineInputContainer: {
		width: '100%',
		'& input': {
			...((style) => ({ ...style.bodyMBold, ...style['secondary-light'] }))(typographyStyle(theme)),
		},
	},
	deleteButton: {
		fontSize: '14px'
	}
});

export default oneLineStyle;
